import get from 'lodash/get'

import {
  fetchResource,
  fetchCollection,
  createResource,
  deleteResource,
  performActionOnResource
} from './index'

import { qaServicingSchema } from '../schemas'

export const QA_SERVICINGS_REQUEST = 'QA_SERVICINGS_REQUEST'
export const QA_SERVICINGS_SUCCESS = 'QA_SERVICINGS_SUCCESS'
export const QA_SERVICINGS_FAILURE = 'QA_SERVICINGS_FAILURE'

function fetchQAServicingsForQAWorkOrder (url, qaWorkOrderId, reload) {
  return fetchCollection({
    url,
    key: 'qaServicings',
    schema: qaServicingSchema,
    actions: [ QA_SERVICINGS_REQUEST, QA_SERVICINGS_SUCCESS, QA_SERVICINGS_FAILURE ],
    responseInterceptor: response => ({ ...response, qaWorkOrderId, reload })
  })
}

export function loadQAServicingsForQAWorkOrder (qaWorkOrderId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.qaServicingsByQAWorkOrder.${qaWorkOrderId}`, {})

    if (!nextPage) {
      nextPageUrl = `/qa_work_orders/${qaWorkOrderId}/qa_servicings`
    }

    return dispatch(fetchQAServicingsForQAWorkOrder(nextPageUrl, qaWorkOrderId, !nextPage))
  }
}

export const QA_SERVICING_REQUEST = 'QA_SERVICING_REQUEST'
export const QA_SERVICING_SUCCESS = 'QA_SERVICING_SUCCESS'
export const QA_SERVICING_FAILURE = 'QA_SERVICING_FAILURE'

export function fetchQAServicing (qaServicingId) {
  return fetchResource({
    url: `/qa_servicings/${qaServicingId}`,
    key: 'qaServicing',
    actions: [ QA_SERVICING_REQUEST, QA_SERVICING_SUCCESS, QA_SERVICING_FAILURE ],
    schema: qaServicingSchema
  })
}

export const CREATE_QA_SERVICING_REQUEST = 'CREATE_QA_SERVICING_REQUEST'
export const CREATE_QA_SERVICING_SUCCESS = 'CREATE_QA_SERVICING_SUCCESS'
export const CREATE_QA_SERVICING_FAILURE = 'CREATE_QA_SERVICING_FAILURE'

export function createQAServicing (qaWorkOrderId, data) {
  return createResource({
    url: `/qa_work_orders/${qaWorkOrderId}/qa_servicings`,
    key: 'qaServicing',
    schema: qaServicingSchema,
    actions: [ CREATE_QA_SERVICING_REQUEST, CREATE_QA_SERVICING_SUCCESS, CREATE_QA_SERVICING_FAILURE ],
    responseInterceptor: response => ({ ...response, qaWorkOrderId }),
    data
  })
}

export const DELETE_QA_SERVICING_REQUEST = 'DELETE_QA_SERVICING_REQUEST'
export const DELETE_QA_SERVICING_SUCCESS = 'DELETE_QA_SERVICING_SUCCESS'
export const DELETE_QA_SERVICING_FAILURE = 'DELETE_QA_SERVICING_FAILURE'

export function deleteQAServicing (qaServicingId) {
  return deleteResource({
    url: `/qa_servicings/${qaServicingId}`,
    actionPayload: { resourceId: qaServicingId },
    actions: [ DELETE_QA_SERVICING_REQUEST, DELETE_QA_SERVICING_SUCCESS, DELETE_QA_SERVICING_FAILURE ]
  })
}

export const COMPLETE_QA_SERVICING_REQUEST = 'COMPLETE_QA_SERVICING_REQUEST'
export const COMPLETE_QA_SERVICING_SUCCESS = 'COMPLETE_QA_SERVICING_SUCCESS'
export const COMPLETE_QA_SERVICING_FAILURE = 'COMPLETE_QA_SERVICING_FAILURE'

export function completeQAServicing (qaServicingId) {
  return performActionOnResource({
    url: `/qa_servicings/${qaServicingId}`,
    action: 'complete',
    key: 'qaServicing',
    schema: qaServicingSchema,
    actions: [ COMPLETE_QA_SERVICING_REQUEST, COMPLETE_QA_SERVICING_SUCCESS, COMPLETE_QA_SERVICING_FAILURE ]
  })
}



// WEBPACK FOOTER //
// ./src/actions/qa-servicings.js